module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo6-f39d3268f9d5867d374fca78dea5dd08.jpg";